import {
    ERROR_EMPTY_ORDERPATTERNCODE,
    ERROR_EMPTY_ORDERPATTERNNAME,
    ERROR_EMPTY_MULTI,
    ERROR_MINIMUM_MINVAL,
    ERROR_MINIMUM_MAXVAL,
    ERROR_MINIMUM_MULTIVAL,
    ERROR_MINMAX_PATTERNCODE,
    ERROR_MIN_MORE_MAX,
    ERROR_INVALID_ORDERPATTERNCODE,
    ERROR_MULTI
} from "../../../../utils/messages";
import { isNullOrEmpty, isWholeNumber } from "../../../../utils/common";
import { EMPTY_COUNT } from "../../../../utils/constants";

function validate(payload) {

    let prompt = [];

    if (isNullOrEmpty(payload.controlPatternCode)) {
        prompt.push(ERROR_EMPTY_ORDERPATTERNCODE);
    } else if (!isWholeNumber(payload.controlPatternCode)) {
        prompt.push(ERROR_INVALID_ORDERPATTERNCODE);
    } else if (EMPTY_COUNT > payload.controlPatternCode) {
        prompt.push(ERROR_MINMAX_PATTERNCODE);
    }

    if (isNullOrEmpty(payload.controlPatternName)) {
        prompt.push(ERROR_EMPTY_ORDERPATTERNNAME);
    }

    if (isNullOrEmpty(payload.multiVal)) {
        prompt.push(ERROR_EMPTY_MULTI);
    } else if (EMPTY_COUNT > payload.multiVal) {
        prompt.push(ERROR_MINIMUM_MULTIVAL);
    }
    

    if (!isNullOrEmpty(payload.minVal)
        && EMPTY_COUNT > payload.minVal) {
        prompt.push(ERROR_MINIMUM_MINVAL);
    }
    if (!isNullOrEmpty(payload.maxVal)){
        if(EMPTY_COUNT > payload.maxVal) {
            prompt.push(ERROR_MINIMUM_MAXVAL);
        }else if(EMPTY_COUNT < payload.multiVal - payload.maxVal){
            prompt.push(ERROR_MULTI);
        }
    }
    if (!(isNullOrEmpty(payload.maxVal)) || (isNullOrEmpty(payload.minVal))){
       if(EMPTY_COUNT < payload.minVal - payload.maxVal) {
        prompt.push(ERROR_MIN_MORE_MAX);
       }
    }


    return prompt;
}


export {
    validate,
};